import React, { Component } from "react";
import { QueryAssistant } from "../home/home";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";
import { Input } from "../forms/input";
import Signbutton from "../forms/button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CustomLoader from "../forms/Loader";
import UploadFile from "../home/uploadFile";
import {
  saveEmpanelData,
  getBankDetails,
  validatePennyDrop,
  getCitiesList,
  saveBankDetails,
} from "../../store/actions/empanelment";
import { connect } from "react-redux";
import CustomizedSelect from "../home/transactions/customizedSelect";
import { MenuItem } from "@material-ui/core";
class Bankdetails extends Component {
  constructor(props) {
    super(props);
    const { storeCAMSData } = this.props;
    this.state = {
      cities: [],
      city: { value: "" },
      nrmawy: { value: "" },
      radioValue: { value: "NO" },
      loader: false,
      ifsc: {
        value:
          !!storeCAMSData &&
          !!storeCAMSData.bankDetails[0] &&
          !!storeCAMSData.bankDetails[0].IFSCcode
            ? storeCAMSData.bankDetails[0].IFSCcode
            : "",
      },
      bnkName: {
        value:
          !!storeCAMSData &&
          !!storeCAMSData.bankDetails[0] &&
          !!storeCAMSData.bankDetails[0].Bank_name
            ? storeCAMSData.bankDetails[0].Bank_name
            : "",
      },
      bnkBranch: {
        value:
          !!storeCAMSData &&
          !!storeCAMSData.bankDetails[0] &&
          !!storeCAMSData.bankDetails[0].Branch
            ? storeCAMSData.bankDetails[0].Branch
            : "",
      },
      bnkCity: {
        value:
          !!storeCAMSData &&
          !!storeCAMSData.bankDetails[0] &&
          !!storeCAMSData.bankDetails[0].City
            ? storeCAMSData.bankDetails[0].City
            : "",
      },
      bnkAccnum: {
        value:
          !!storeCAMSData &&
          !!storeCAMSData.bankDetails[0] &&
          !!storeCAMSData.bankDetails[0].Accountnumber
            ? storeCAMSData.bankDetails[0].Accountnumber
            : "",
      },
      nsdl: { value: "" },
      cdsl: { value: "" },
      count: 1,
      file: {},
      upload: { errorMessage: "" },
    };
  }
  async componentDidMount() {
    if (!!this.props.bankState.city) {
      this.setState((prevState) => ({
        ...prevState,
        ...this.props.bankState,
        count: 1,
        loader: false,
      }));
      return;
    }
    try {
      this.setState({ loader: true });
      const response = await this.props.getCitiesList();
      if (!!response && !!response.Dtinformation) {
        const cities = response.Dtinformation;
        cities.length > 0 && this.setState({ cities: cities });
      }
    } catch (e) {
      alert(e);
    } finally {
      this.setState({ loader: false });
    }
  }
  getBankDetails = async () => {
    if (/^[A-Za-z]{4}[a-zA-Z0-9]{7}$/.test(this.state.ifsc.value)) {
      const response = await this.props.getBankDetails({
        ifsc: this.state.ifsc.value,
      });
      const data = response.Dtinformation[0];
      if (this.state.radioValue.value === "YES") {
        this.setState({
          ifsc: {
            value: this.state.ifsc.value,
            isError: false,
            errorMessage: "",
          },
          bnkName: { value: data.bankname },
          bnkCity: { value: data.bankcity },
          bnkBranch: { value: data.bankadd1 },
        });
      }
    } else {
      this.setState({
        ifsc: {
          value: "",
          isError: true,
          errorMessage: "Please enter a valid IFSC number",
        },
      });
    }
  };
  validate = (label) => (event) => {
    if (label === "cdsl") {
      if (!/^(\d{16})$/.test(event.target.value)) {
        this.setState({
          cdsl: {
            value: "",
            isError: true,
            errorMessage: "Enter a Valid CDSL ID",
          },
        });
      }
    } else {
      if (!/^(\d{14})$/.test(event.target.value)) {
        this.setState({
          nsdl: {
            value: "",
            isError: true,
            errorMessage: "Enter a Valid NSDL ID",
          },
        });
      }
    }
  };
  changeValue = (label) => (event) => {
    if (label === "ifsc") {
      this.setState({
        [label]: { value: event.target.value.toUpperCase() },
      });
    } else {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };
  changeCity = (e) => {
    const city = e.target.value;
    this.setState({
      city: { value: city },
    });
  };
  fileUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      this.setState({
        [label]: file.name,
      });

      var fileReader = new FileReader();
      var base64;
      // Onload of file read the file content
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        this.setState({
          file: { value: base64.split(",")[1] },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
      this.setState({
        upload: { errorMessage: "Upload Successfully" },
      });
    }
  };
  submit = async () => {
    const {
      city,
      nrmawy,
      nsdl,
      cdsl,
      loader,
      cities,
      count,
      upload_file,
      upload,
      file,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "ifsc"
                  ? "IFSC Code"
                  : key === "bnkName"
                  ? "Bank Name"
                  : key === "bnkAccnum"
                  ? "Account Number"
                  : key === "bnkCity"
                  ? "Bank City"
                  : key === "bnkBranch"
                  ? "Brank Branch"
                  : key
              } is mandatory`,
            },
          });
      });
      return;
    } else if (!/^[A-Za-z]{4}[a-zA-Z0-9]{7}$/.test(this.state.ifsc.value)) {
      this.setState({
        ifsc: {
          value: "",
          isError: true,
          errorMessage: "Please enter a valid IFSC number",
        },
      });
      return;
    } else if (!!cdsl.value && !/^(\d{16})$/.test(cdsl.value)) {
      this.setState({
        cdsl: {
          value: "",
          isError: true,
          errorMessage: "Enter a Valid CDSL ID",
        },
      });
      return;
    } else if (!!nsdl.value && !/^(\d{14})$/.test(nsdl.value)) {
      this.setState({
        nsdl: {
          value: "",
          isError: true,
          errorMessage: "Enter a Valid NSDL ID",
        },
      });
      return;
    }

    const { ifsc, bnkName, bnkAccnum, bnkBranch, bnkCity } = this.state;
    const bankdetails = {
      AMC_Branch: this.state.city.value,
      rmname: this.state.nrmawy.value,
      ifsc: ifsc.value,
      bnkName: bnkName.value,
      bnkAccnum: bnkAccnum.value,
      bnkBranch: bnkBranch.value,
      bnkCity: bnkCity.value,
      nsdl: !!nsdl.value ? "IN" + nsdl.value : "",
      cdsl: cdsl.value,
    };
    this.props.saveBankDetails({
      ...bankdetails,
    });

    // if (this.state.radioValue.value === "YES") {
    //   this.setState({ loader: true });
    //   const params = {
    //     IFSC: ifsc.value,
    //     AccountNo: bnkAccnum.value,
    //     MobileNo: this.props.storeCAMSData.bankDetails[0].MOBILE_NO1,
    //     PAN: this.props.storeCAMSData.bankDetails[0].PAN,
    //     InvestorName: this.props.storeCAMSData.bankDetails[0].ARN_NAME,
    //     Ip: "10.192.18.119",
    //     RequestKey: "8ad82821-f99b-4556-8558-230d37995341",
    //     RequestType: "PennyDrop",
    //     consent: "Y",
    //     Fund: 189,
    //     APPId: "WB99",
    //   };
    //   try {
    //     const res = await this.props.validatePennyDrop(params);
    //     const data = JSON.parse(res);
    //     const { Status, Result } = data;
    //     if ((Status !== "Y" || Result === "False") && this.state.count === 1) {
    //       alert(
    //         "Bank Account Validation is Failed, Please enter the correct bank details"
    //       );
    //       this.setState((prevState) => ({
    //         loader: false,
    //         radioValue: { value: "YES" },
    //         ifsc: {
    //           value: "",
    //           isError: true,
    //           errorMessage: "Enter a valid IFSC Code",
    //         },
    //         bnkName: {
    //           value: "",
    //         },
    //         bnkAccnum: {
    //           value: "",
    //           isError: true,
    //           errorMessage: "Enter a valid Bank Account Number",
    //         },
    //         bnkBranch: {
    //           value: "",
    //         },
    //         bnkCity: {
    //           value: "",
    //         },
    //         cdsl: { value: "" },
    //         nsdl: { value: "" },
    //         count: prevState.count + 1,
    //       }));
    //       return;
    //     } else if (
    //       (Status !== "Y" || Result === "False") &&
    //       this.state.count > 1
    //     ) {
    //       alert(
    //         "Dear Partner, the Bank Validation has failed and empanelment will take place with the bank account as per your input. Please refer the detailed welcome email and will request you to proceed with the Change of Bank"
    //       );
    //       this.props.saveBankDetails({ ...bankdetails, pennydropflag: "N" });
    //       this.props.history.push("/distributor-empanellement/nominee-details");
    //     } else {
    //       this.props.saveBankDetails({
    //         ...bankdetails,
    //         pennydropflag: "Y",
    //       });
    //       this.props.history.push("/distributor-empanellement/nominee-details");
    //     }
    //   } catch (e) {
    //     alert(e);
    //   } finally {
    //     this.setState({ loader: false });
    //   }
    // } else {
    //   this.props.saveBankDetails({
    //     ...bankdetails,
    //     pennydropflag: "C",
    //   });
    //   this.props.history.push("/distributor-empanellement/nominee-details");
    // }
    this.props.history.push("/distributor-empanellement/nominee-details");
  };
  fillDetails = () => (event) => {
    if (event.target.value === "YES") {
      this.setState({
        radioValue: { value: "YES" },
        ifsc: { value: "" },
        bnkName: { value: "" },
        bnkAccnum: { value: "" },
        bnkBranch: { value: "" },
        bnkCity: { value: "" },
        cdsl: { value: "" },
        nsdl: { value: "" },
      });
    } else if (event.target.value === "NO") {
      this.setState({
        radioValue: { value: "NO" },
        ifsc: {
          value:
            (!!this.props.storeCAMSData.bankDetails[0] &&
              this.props.storeCAMSData.bankDetails[0].IFSCcode) ||
            "",
        },
        bnkName: {
          value:
            (!!this.props.storeCAMSData.bankDetails[0] &&
              this.props.storeCAMSData.bankDetails[0].Bank_name) ||
            "",
        },
        bnkBranch: {
          value:
            (!!this.props.storeCAMSData.bankDetails[0] &&
              this.props.storeCAMSData.bankDetails[0].Branch) ||
            "",
        },
        bnkCity: {
          value:
            (!!this.props.storeCAMSData.bankDetails[0] &&
              this.props.storeCAMSData.bankDetails[0].City) ||
            "",
        },
        bnkAccnum: {
          value:
            (!!this.props.storeCAMSData.bankDetails[0] &&
              this.props.storeCAMSData.bankDetails[0].Accountnumber) ||
            "",
        },
      });
    }
  };
  render() {
    const {
      city,
      nrmawy,
      ifsc,
      bnkName,
      bnkAccnum,
      bnkBranch,
      bnkCity,
      radioValue,
      cdsl,
      nsdl,
      cities,
    } = this.state;
    return (
      <div className="login-container">
        {/* <QueryAssistant /> */}
        <Appbar />
        <CustomLoader display={this.state.loader} />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            {/* <div className="eijaca">
              Please select AMC Branch Associated with
            </div>

            <div className="input-margin">
              <CustomizedSelect
                name="City"
                handleChange={this.changeCity}
                isError={city.isError}
                errorMessage={city.errorMessage}
                inputref={(ele) => (this.cityFieled = ele)}
                value={city.value}
              >
                {cities.map((s) => (
                  <MenuItem value={s.city}>{s.city}</MenuItem>
                ))}
              </CustomizedSelect>
            </div>

            <div className="input-margin">
              <Input maxLength={50}
                name="Name of RM associated with you"
                value={nrmawy.value}
                onChange={this.changeValue("nrmawy")}
                isShowError={nrmawy.isError}
                errorMessage={nrmawy.errorMessage}
                inputref={(ele) => (this.nrmawyField = ele)}
              />
            </div>
            <div className="input-margin">
              <div className="eijaca input-margin">
                If you have depository account and willing to share your DP IDs,
                please share your CDSL / NSDL ID
              </div>
              <Input maxLength={50}
                name="CDSL ID(Optional)"
                value={cdsl.value}
                onChange={this.changeValue("cdsl")}
                isShowError={cdsl.isError}
                errorMessage={cdsl.errorMessage}
                inputref={(ele) => (this.nrmawyField = ele)}
                tooltip="An unique 16-digit number provided to every Demat account by CDSL"
                onBlur={this.validate("cdsl")}
                type="number"
              />
            </div>
            <div className="input-margin">
              <Input maxLength={50}
                name="NSDL ID(Optional)"
                value={nsdl.value}
                onChange={this.changeValue("nsdl")}
                isShowError={nsdl.isError}
                errorMessage={nsdl.errorMessage}
                inputref={(ele) => (this.nsdlField = ele)}
                tooltip='An unique 14-digit number provided to every Demat account by NSDL (Prefixed with "IN")'
                onBlur={this.validate("nsdl")}
                type="number"
              />
            </div> */}

            <div className="login-title">Bank Details</div>

            <div className="input-field-container">
              <div className="input-name">Choose an Option*</div>

              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="Search"
                  name="search"
                  value={radioValue.value}
                  style={{ flexDirection: "row" }}
                  onChange={this.fillDetails("radioValue")}
                >
                  <div className="investor-radio-button input-margin">
                    <FormControlLabel
                      value="NO"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">
                      Get the bank details from CDMS database
                    </div>
                  </div>
                  <div className="investor-radio-button input-margin">
                    <FormControlLabel
                      value="YES"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">
                      Update bank account details
                    </div>
                  </div>
                </RadioGroup>
              </FormControl>
            </div>

            <div className="input-margin">
              <Input
                maxLength={50}
                name="IFSC Code*"
                value={ifsc.value}
                onChange={this.changeValue("ifsc")}
                onBlur={this.getBankDetails}
                isShowError={ifsc.isError}
                errorMessage={ifsc.errorMessage}
                inputref={(ele) => (this.ifscField = ele)}
                placeholder={"Please enter IFSC Code"}
              />
            </div>

            <div className="input-margin">
              <Input
                maxLength={50}
                name="Bank Name*"
                value={bnkName.value}
                onChange={this.changeValue("bnkName")}
                isShowError={bnkName.isError}
                errorMessage={bnkName.errorMessage}
                inputref={(ele) => (this.bnkNameField = ele)}
                placeholder={"Please enter Bank Name"}
              />
            </div>

            <div className="input-margin">
              <Input
                maxLength={50}
                name="Bank Account Number*"
                value={bnkAccnum.value}
                onChange={this.changeValue("bnkAccnum")}
                isShowError={bnkAccnum.isError}
                errorMessage={bnkAccnum.errorMessage}
                inputref={(ele) => (this.bnkAccnumField = ele)}
                placeholder={"Please enter Bank Account Number"}
              />
            </div>
            <div className="input-margin">
              <Input
                maxLength={50}
                name="Bank Branch*"
                value={bnkBranch.value}
                onChange={this.changeValue("bnkBranch")}
                isShowError={bnkBranch.isError}
                errorMessage={bnkBranch.errorMessage}
                inputref={(ele) => (this.bnkBranchField = ele)}
                placeholder={"Please enter Bank Branch"}
              />
            </div>
            <div className="input-margin">
              <Input
                maxLength={50}
                name="Bank City*"
                value={bnkCity.value}
                onChange={this.changeValue("bnkCity")}
                isShowError={bnkCity.isError}
                errorMessage={bnkCity.errorMessage}
                inputref={(ele) => (this.bnkCityField = ele)}
                placeholder={"Please enter Bank City"}
              />
            </div>
            <div className="input-margin">
              <div className="input-name">Upload Cancelled Cheque</div>

              {!!this.state.upload.errorMessage ? (
                <div
                  style={{
                    color:
                      !!this.state.upload.errorMessage &&
                      this.state.upload.errorMessage == "Upload Successfully"
                        ? "green"
                        : "red",
                    fontFamily: "Rubik-Italic",
                    fontSize: 15,
                  }}
                >
                  {this.state.upload.errorMessage}
                </div>
              ) : (
                ""
              )}
              <UploadFile
                id="upload_file"
                uploadFile={this.fileUpload}
                accept={"application/pdf"}
                fileName={this.state.upload_file}
                isShowError={this.state.file.isError}
              />
              <div className="euin-text">
                only pdf files are allowed, File size to not exceed 24 MB
              </div>
            </div>
            <Signbutton buttontitle="Submit" onClick={this.submit} />
            <span
              className="login-no-account-span mouse-pointer"
              onClick={() =>
                this.props.history.push("/distributor-empanellement")
              }
            >
              Back
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { camsdata, empanelmentData, bankState, storeCAMSData } = authReducer;
    return {
      camsdata,
      empanelmentData,
      bankState,
      storeCAMSData,
    };
  },
  {
    saveEmpanelData,
    getBankDetails,
    validatePennyDrop,
    getCitiesList,
    saveBankDetails,
  }
)(Bankdetails);
